import i18n from "../i18n";

const resolveBaseUrl = (): string => {
  /** Prefer `REACT_APP_API_URL` in `.env` (see `.env.example`). Never use the CRA dev port as the API. */
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  if (envUrl) return envUrl.replace(/\/+$/, "");

  /**
   * Dev fallback matches `package.json` "proxy": API on :3003, React on :3000 (`PORT` in `.env`).
   */
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3003".replace(/\/+$/, "");
  }

  const browserOrigin =
    typeof window !== "undefined" ? window.location.origin : "";
  return (browserOrigin || "").replace(/\/+$/, "");
};

const normalizedBase = resolveBaseUrl();

export const serverApiBase: string = normalizedBase;
export const serverApi: string = normalizedBase ? `${normalizedBase}/` : "/";

function coerceImagePath(
  imagePath: string | Record<string, unknown> | undefined | null
): string {
  if (imagePath == null) return "";
  if (typeof imagePath === "string") return imagePath.trim();
  const o = imagePath as Record<string, unknown>;
  for (const k of ["url", "path", "src", "image"]) {
    const v = o[k];
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return "";
}

export const getImageUrl = (
  imagePath: string | Record<string, unknown> | undefined | null
): string => {
  const p = coerceImagePath(imagePath);
  if (!p) return "";
  if (p.startsWith("http://") || p.startsWith("https://")) return p;
  if (p.startsWith("//")) {
    if (typeof window !== "undefined" && window.location?.protocol) {
      return `${window.location.protocol}${p}`;
    }
    return `https:${p}`;
  }
  const path = p.startsWith("/") ? p : `/${p}`;
  return `${serverApiBase}${path}`;
};

/** Read at call time so messages follow the current language. */
export const Messages = {
  get error1() {
    return i18n.t("messages.error1");
  },
  get error2() {
    return i18n.t("messages.error2");
  },
  get error3() {
    return i18n.t("messages.error3");
  },
  get error4() {
    return i18n.t("messages.error4");
  },
  get error5() {
    return i18n.t("messages.error5");
  },
};
